import { render, staticRenderFns } from "./BotaoTerritorio.vue?vue&type=template&id=7fed95cf&lang=pug"
import script from "./BotaoTerritorio.vue?vue&type=script&lang=js"
export * from "./BotaoTerritorio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports